/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BeMusic
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CancelSubscriptionBody} from './schemas/cancel-subscription-body';

import type {ChangeSubscriptionPlanBody} from './schemas/change-subscription-plan-body';

import type {ChangeSubscriptionPlan200} from './schemas/change-subscription-plan200';

import type {CreateProduct201} from './schemas/create-product201';

import type {CreateSubscription201} from './schemas/create-subscription201';

import type {CrupdateProductBody} from './schemas/crupdate-product-body';

import type {CrupdateSubscriptionBody} from './schemas/crupdate-subscription-body';

import type {ListProductsParams} from './schemas/list-products-params';

import type {ListProducts200} from './schemas/list-products200';

import type {ListSubscriptionsParams} from './schemas/list-subscriptions-params';

import type {ListSubscriptions200} from './schemas/list-subscriptions200';

import type {ResumeSubscription200} from './schemas/resume-subscription200';

import type {RetrieveProduct200} from './schemas/retrieve-product200';

import type {UpdateProduct200} from './schemas/update-product200';

import type {UpdateSubscription200} from './schemas/update-subscription200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all products
 */
export const listProducts = (
  params?: ListProductsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListProducts200>>,
) => {
  return orvalApiFetch<ListProducts200>(
    {url: `/billing/products`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a product
 */
export const createProduct = (
  crupdateProductBody?: CrupdateProductBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateProduct201>>,
) => {
  return orvalApiFetch<CreateProduct201>(
    {
      url: `/billing/products`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateProductBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a product
 */
export const retrieveProduct = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveProduct200>>,
) => {
  return orvalApiFetch<RetrieveProduct200>(
    {url: `/billing/products/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a product
 */
export const updateProduct = (
  id: number,
  crupdateProductBody?: CrupdateProductBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateProduct200>>,
) => {
  return orvalApiFetch<UpdateProduct200>(
    {
      url: `/billing/products/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateProductBody,
    },
    options,
  );
};
/**
 * @summary Delete a product
 */
export const deleteProduct = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/billing/products/${id}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Sync all products to enabled payment gateways
 */
export const syncProducts = (
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/billing/products/sync`, method: 'POST'},
    options,
  );
};
/**
 * @summary List all subscriptions
 */
export const listSubscriptions = (
  params?: ListSubscriptionsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListSubscriptions200>>,
) => {
  return orvalApiFetch<ListSubscriptions200>(
    {url: `/billing/subscriptions`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a subscription
 */
export const createSubscription = (
  crupdateSubscriptionBody: CrupdateSubscriptionBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateSubscription201>>,
) => {
  return orvalApiFetch<CreateSubscription201>(
    {
      url: `/billing/subscriptions`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateSubscriptionBody,
    },
    options,
  );
};
/**
 * @summary Cancel a subscription
 */
export const cancelSubscription = (
  id: number,
  cancelSubscriptionBody?: CancelSubscriptionBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/billing/subscriptions/${id}/cancel`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: cancelSubscriptionBody,
    },
    options,
  );
};
/**
 * @summary Update a subscription
 */
export const updateSubscription = (
  id: number,
  crupdateSubscriptionBody: CrupdateSubscriptionBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateSubscription200>>,
) => {
  return orvalApiFetch<UpdateSubscription200>(
    {
      url: `/billing/subscriptions/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateSubscriptionBody,
    },
    options,
  );
};
/**
 * @summary Resume a subscription
 */
export const resumeSubscription = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<ResumeSubscription200>>,
) => {
  return orvalApiFetch<ResumeSubscription200>(
    {url: `/billing/subscriptions/${id}/resume`, method: 'POST'},
    options,
  );
};
/**
 * @summary Change subscription plan
 */
export const changeSubscriptionPlan = (
  id: number,
  changeSubscriptionPlanBody: ChangeSubscriptionPlanBody,
  options?: SecondParameter<typeof orvalApiFetch<ChangeSubscriptionPlan200>>,
) => {
  return orvalApiFetch<ChangeSubscriptionPlan200>(
    {
      url: `/billing/subscriptions/${id}/change-plan`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: changeSubscriptionPlanBody,
    },
    options,
  );
};
export type ListProductsResult = NonNullable<
  Awaited<ReturnType<typeof listProducts>>
>;
export type CreateProductResult = NonNullable<
  Awaited<ReturnType<typeof createProduct>>
>;
export type RetrieveProductResult = NonNullable<
  Awaited<ReturnType<typeof retrieveProduct>>
>;
export type UpdateProductResult = NonNullable<
  Awaited<ReturnType<typeof updateProduct>>
>;
export type DeleteProductResult = NonNullable<
  Awaited<ReturnType<typeof deleteProduct>>
>;
export type SyncProductsResult = NonNullable<
  Awaited<ReturnType<typeof syncProducts>>
>;
export type ListSubscriptionsResult = NonNullable<
  Awaited<ReturnType<typeof listSubscriptions>>
>;
export type CreateSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof createSubscription>>
>;
export type CancelSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof cancelSubscription>>
>;
export type UpdateSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscription>>
>;
export type ResumeSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof resumeSubscription>>
>;
export type ChangeSubscriptionPlanResult = NonNullable<
  Awaited<ReturnType<typeof changeSubscriptionPlan>>
>;
